import type { BillingOverviewDto, BillingProfileDto, CheckoutStatusDto, PaymentsInfoDto, SubscriptionDto } from '@dbrain/shared';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCapabilities, useMeta } from '../experience.js';
import { api } from './client.js';
import { keys } from './hooks.js';
import { planKeys } from './plan.js';

/**
 * Phase 16c (ADR-0023 §11): the subscription where the edition has billing (bireysel). Whether Pro can be bought now is
 * the meta's (a provider is configured); until then "Pro'ya geç" says payments open soon.
 */
export const billingKeys = { overview: ['billing'] as const };

export function usePayments(): PaymentsInfoDto {
  const meta = useMeta().data;
  return meta?.payments ?? { open: false, provider: null, test: false };
}

export function useBillingOverview(enabled = true) {
  const capabilities = useCapabilities();
  return useQuery({ queryKey: billingKeys.overview, queryFn: () => api<BillingOverviewDto>('GET', '/api/billing'), enabled: capabilities.billing && enabled });
}

/** After a step of the subscription: the overview, the person's plan and today's use are read again */
export function useBillingRefresh() {
  const queryClient = useQueryClient();
  return (subscription?: SubscriptionDto | null) => {
    if (subscription !== undefined) queryClient.setQueryData<BillingOverviewDto>(billingKeys.overview, (old) => (old ? { ...old, subscription } : old));
    void queryClient.invalidateQueries({ queryKey: billingKeys.overview });
    void queryClient.invalidateQueries({ queryKey: keys.me });
    void queryClient.invalidateQueries({ queryKey: planKeys.usage });
  };
}

export const saveProfile = (body: unknown) => api<BillingProfileDto>('PUT', '/api/billing/profile', body);
export const checkoutStatus = (orderId: string) => api<CheckoutStatusDto>('GET', `/api/billing/checkout/${orderId}`);
